var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Space settings","section":"External storage"}},[_c('space-external-storage',{attrs:{"space-id":_vm.activeSpaceId,"is-space-admin-override":_vm.isSpaceAdmin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }